import React from 'react';

export const OptedOutBanner = () => {
  return (
    <div className="opted-out-banner">
      <p>Opted out of receiving messages</p>
    </div>
  );
};
